module.exports = __webpack_public_path__ + "static/hchoneysticks-a4915f6f0b830c23ffdd0612a6351964.jpg";